import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICreateTermoUsoVersao, IGetLastTermoVersaoByTipoRequest } from './termoUso.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TermoUsoService {

  constructor(private http: HttpClient) {}

  public CreateTermoUsoVersao(data: ICreateTermoUsoVersao): Observable<any> {
    const formData = new FormData();

    formData.append('File', data.file);
    formData.append('TipoTermoUso', data.tipoTermoUso.toString());
    formData.append('IsEpsa', data.isEpsa.toString());

    return this.http.post<any>(
      `${environment.baseURL}TermoUso/CreateTermoUsoVersao`,
      formData
    );
  }

  public GetLastTermoVersaoByTipo(data: IGetLastTermoVersaoByTipoRequest): Observable<any> {
    const url = `${environment.baseURL}TermoUso/GetLastTermoVersaoByTipo?TipoTermo=${data.TipoTermo}&IsEpsa=${data.IsEpsa}`;

    return this.http.get<any>(url);
  }

}
